/**
 * Meta Pixel Event Tracking Utilities
 * IMPORTANT: Uses event_id for deduplication with Conversions API
 */

// Track page views (already done in index.html)
export const trackPageView = () => {
  if (window.fbq) {
    window.fbq('track', 'PageView');
  }
};

// Track when user views content
export const trackViewContent = (product) => {
  if (window.fbq) {
    // Use consistent event_id for deduplication with backend
    const eventId = `view_${product.id}_${Date.now()}`;
    window.fbq('track', 'ViewContent', {
      content_name: product.name,
      content_ids: [product.id],
      content_type: 'product',
      value: product.price,
      currency: 'IQD' // Changed from ILS to IQD for Iraqi Dinar
    }, { eventID: eventId });
  }
};

// Track when user adds to cart
export const trackAddToCart = (product, quantity = 1) => {
  if (window.fbq) {
    // Use consistent event_id for deduplication with backend
    const eventId = `addtocart_${product.id}_${Date.now()}`;
    window.fbq('track', 'AddToCart', {
      content_name: product.name,
      content_ids: [product.id],
      content_type: 'product',
      value: product.price * quantity,
      currency: 'IQD'
    }, { eventID: eventId });
  }
};

// Track when user initiates checkout
export const trackInitiateCheckout = (cartItems, totalValue) => {
  if (window.fbq) {
    // Use consistent event_id for deduplication with backend
    const eventId = `checkout_${Date.now()}`;
    window.fbq('track', 'InitiateCheckout', {
      content_ids: cartItems.map(item => item.id),
      contents: cartItems.map(item => ({
        id: item.id,
        quantity: item.quantity
      })),
      value: totalValue,
      currency: 'IQD',
      num_items: cartItems.length
    }, { eventID: eventId });
  }
};

// Track when user completes purchase
export const trackPurchase = (orderId, cartItems, totalValue) => {
  if (window.fbq) {
    // CRITICAL: Use order ID as event_id for perfect deduplication with backend
    const eventId = `purchase_${orderId}`;
    window.fbq('track', 'Purchase', {
      content_ids: cartItems.map(item => item.id),
      contents: cartItems.map(item => ({
        id: item.id,
        quantity: item.quantity,
        price: item.price
      })),
      value: totalValue,
      currency: 'IQD',
      num_items: cartItems.length,
      order_id: orderId
    }, { eventID: eventId });
  }
};

// Track search
export const trackSearch = (searchQuery) => {
  if (window.fbq) {
    const eventId = `search_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    window.fbq('track', 'Search', {
      search_string: searchQuery
    }, { eventID: eventId });
  }
};

// Track when user adds payment info
export const trackAddPaymentInfo = () => {
  if (window.fbq) {
    window.fbq('track', 'AddPaymentInfo');
  }
};

// Track lead (e.g., sign up, contact form)
export const trackLead = () => {
  if (window.fbq) {
    window.fbq('track', 'Lead');
  }
};
